import { SubdivisionEntryView } from '@/api/apis/facilities';
import { useCountriesData } from '@/contexts/CountriesDataProvider';
import { NameByValue } from '@/types';

export const DEFAULT_STATE_LABEL = 'State / Region';

export const getCountryHasStates = (
  composedSubdivisionsList: Record<string, NameByValue[]>,
  country: string,
): boolean => (composedSubdivisionsList[country]?.length ?? 0) > 0;

export const getStateLabel = (subdivisions: Record<string, SubdivisionEntryView[]>, country: string): string =>
  [...new Set((subdivisions[country] ?? []).map((s) => s.type))].join('/') || DEFAULT_STATE_LABEL;

export const useCountrySubdivisionInfo = (country: string) => {
  const { composedSubdivisionsList } = useCountriesData();

  return {
    countryHasStates: getCountryHasStates(composedSubdivisionsList, country),
    // hardcoded for now, dynamic value calculated by getStateLabel
    stateLabel: DEFAULT_STATE_LABEL,
  };
};
